var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadViewArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 33,
    viewBox: "0 0 19 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.152 13.0926L3.70883 12.8611L4.152 13.0926ZM18.4374 0.978515L12.7151 0.210759L14.9114 5.55023L18.4374 0.978515ZM2.28762 32.7041C0.700715 26.1589 1.53254 19.1865 4.59516 13.3241L3.70883 12.8611C0.531865 18.9423 -0.327158 26.1635 1.31578 32.9397L2.28762 32.7041ZM4.59516 13.3241C6.92374 8.86684 10.3938 5.33414 14.5112 3.13129L14.0395 2.24955C9.73573 4.5521 6.12544 8.23528 3.70883 12.8611L4.59516 13.3241Z",
    fill: "#5990E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadViewArrow);
export default __webpack_public_path__ + "static/media/leadViewArrow.128ba27bbfa25bdcd005478421587c02.svg";
export { ForwardRef as ReactComponent };